import React from 'react';

const NumericMetricConfig = ({ 
  metricName, 
  unit, 
  statusConfig, 
  onStatusConfigChange 
}) => {
  const { operational, degraded, outage } = statusConfig;

  const handleOperationalChange = (field, value) => {
    const newConfig = {
      ...statusConfig,
      operational: { ...operational, [field]: value }
    };
    onStatusConfigChange(newConfig);
  };

  const handleDegradedChange = (field, value) => {
    const newConfig = {
      ...statusConfig,
      degraded: { ...degraded, [field]: value }
    };
    onStatusConfigChange(newConfig);
  };

  const handleOutageChange = (field, value) => {
    const newConfig = {
      ...statusConfig,
      outage: { ...outage, [field]: value }
    };
    onStatusConfigChange(newConfig);
  };

  return (
    <div className="status-config">
      <h4>Status Configuration</h4>
      
      <div className="form-group">
        <label>Operational</label>
        <div className="status-row">
          <span>if {(metricName || 'metric').toLowerCase()} is</span>
          <select
            value={operational.operator}
            onChange={(e) => handleOperationalChange('operator', e.target.value)}
          >
            <option value="=">=</option>
            <option value=">=">≥</option>
            <option value="<=">≤</option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
            <option value="range">range</option>
          </select>
          {operational.operator === 'range' ? (
            <>
              <input
                type="number"
                value={operational.min || ''}
                onChange={(e) => handleOperationalChange('min', parseFloat(e.target.value))}
                placeholder="7"
                step="0.1"
                required
              />
              <span>to</span>
              <input
                type="number"
                value={operational.max || ''}
                onChange={(e) => handleOperationalChange('max', parseFloat(e.target.value))}
                placeholder="10"
                step="0.1"
                required
              />
            </>
          ) : (
            <input
              type="number"
              value={operational.value || ''}
              onChange={(e) => handleOperationalChange('value', parseFloat(e.target.value))}
              placeholder="0"
              step="0.1"
              required
            />
          )}
          <span>{(unit || 'unit').toLowerCase()}</span>
        </div>
      </div>
      
      <div className="form-group">
        <label>Degraded</label>
        <div className="status-row">
          <span>if {(metricName || 'metric').toLowerCase()} is</span>
          <select
            value={degraded.operator}
            onChange={(e) => handleDegradedChange('operator', e.target.value)}
          >
            <option value="=">=</option>
            <option value=">=">≥</option>
            <option value="<=">≤</option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
            <option value="range">range</option>
          </select>
          {degraded.operator === 'range' ? (
            <>
              <input
                type="number"
                value={degraded.min || ''}
                onChange={(e) => handleDegradedChange('min', parseFloat(e.target.value))}
                placeholder="6"
                step="0.1"
                required
              />
              <span>to</span>
              <input
                type="number"
                value={degraded.max || ''}
                onChange={(e) => handleDegradedChange('max', parseFloat(e.target.value))}
                placeholder="6.9"
                step="0.1"
                required
              />
            </>
          ) : (
            <input
              type="number"
              value={degraded.value || ''}
              onChange={(e) => handleDegradedChange('value', parseFloat(e.target.value))}
              placeholder="0"
              step="0.1"
              required
            />
          )}
          <span>{(unit || 'unit').toLowerCase()}</span>
        </div>
      </div>
      
      <div className="form-group">
        <label>Outage</label>
        <div className="status-row">
          <span>if {(metricName || 'metric').toLowerCase()} is</span>
          <select
            value={outage.operator}
            onChange={(e) => handleOutageChange('operator', e.target.value)}
          >
            <option value="=">=</option>
            <option value=">=">≥</option>
            <option value="<=">≤</option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
            <option value="range">range</option>
          </select>
          {outage.operator === 'range' ? (
            <>
              <input
                type="number"
                value={outage.min || ''}
                onChange={(e) => handleOutageChange('min', parseFloat(e.target.value))}
                placeholder="0"
                step="0.1"
                required
              />
              <span>to</span>
              <input
                type="number"
                value={outage.max || ''}
                onChange={(e) => handleOutageChange('max', parseFloat(e.target.value))}
                placeholder="5.9"
                step="0.1"
                required
              />
            </>
          ) : (
            <input
              type="number"
              value={outage.value || ''}
              onChange={(e) => handleOutageChange('value', parseFloat(e.target.value))}
              placeholder="0"
              step="0.1"
              required
            />
          )}
          <span>{(unit || 'unit').toLowerCase()}</span>
        </div>
      </div>
    </div>
  );
};

export default NumericMetricConfig;
